import React, { useMemo, useState } from 'react';

const EMAIL_PROVIDERS = [
  'gmail.com',
  'hotmail.com',
  'yahoo.com',
  'outlook.com',
  'live.com',
  'icloud.com',
  'msn.com',
  'ymail.com',
  'googlemail.com',
  'proton.me',
  'protonmail.com',
  'gmx.com',
  'aol.com',
  'mail.com',
  'yandex.com',
  'sbb.rs',
  'eunet.rs',
  'mts.rs',
  'open.telekom.rs'
];

const getSuggestions = (value) => {
  const raw = value || '';
  const at = raw.indexOf('@');
  if (at <= 0 || raw.indexOf('@', at + 1) !== -1) return [];

  const local = raw.slice(0, at);
  if (!local.trim() || /\s/.test(local)) return [];

  const domain = raw.slice(at + 1).toLowerCase();
  return EMAIL_PROVIDERS
    .filter((provider) => provider.startsWith(domain) && provider !== domain)
    .slice(0, 8)
    .map((provider) => `${local}@${provider}`);
};

const EmailProviderInput = ({
  name = 'email',
  value,
  onChange,
  className,
  placeholder,
  id
}) => {
  const [open, setOpen] = useState(false);
  const [highlight, setHighlight] = useState(0);
  const suggestions = useMemo(() => getSuggestions(value), [value]);
  const show = open && suggestions.length > 0;
  const activeIndex = show ? Math.min(highlight, suggestions.length - 1) : 0;

  const select = (suggestion) => {
    onChange({ target: { name, value: suggestion } });
    setOpen(false);
    setHighlight(0);
  };

  const onKeyDown = (event) => {
    if (!show) return;

    if (event.key === 'ArrowDown') {
      event.preventDefault();
      setHighlight((activeIndex + 1) % suggestions.length);
      return;
    }

    if (event.key === 'ArrowUp') {
      event.preventDefault();
      setHighlight((activeIndex - 1 + suggestions.length) % suggestions.length);
      return;
    }

    if (event.key === 'Enter') {
      event.preventDefault();
      select(suggestions[activeIndex]);
      return;
    }

    if (event.key === 'Escape') {
      event.preventDefault();
      setOpen(false);
    }
  };

  return (
    <div className={`relative ${show ? 'z-30' : ''}`}>
      <input
        id={id}
        type="text"
        inputMode="email"
        autoComplete="off"
        name={name}
        value={value}
        placeholder={placeholder}
        className={className}
        onChange={(event) => {
          setOpen(true);
          setHighlight(0);
          onChange(event);
        }}
        onFocus={() => setOpen(true)}
        onBlur={() => setOpen(false)}
        onKeyDown={onKeyDown}
      />
      {show && (
        <ul className="absolute left-0 right-0 z-30 mt-1 overflow-hidden rounded-lg border border-gray-600 bg-gray-800 shadow-lg">
          {suggestions.map((suggestion, index) => (
            <li key={suggestion}>
              <button
                type="button"
                onMouseDown={(event) => event.preventDefault()}
                onMouseEnter={() => setHighlight(index)}
                onClick={() => select(suggestion)}
                className={`w-full px-3 py-2 text-left text-sm ${
                  index === activeIndex
                    ? 'bg-blue-600 text-white'
                    : 'text-gray-200 hover:bg-gray-700'
                }`}
              >
                {suggestion}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default EmailProviderInput;
